import { reactQueryUtils } from "@lib/react-query";
import { useMutation } from "@tanstack/react-query";
import { analyticsApi } from "./analytics.api";
import { analyticsKeys } from "./analytics.keys";

export const useDeleteSessionsMutation = () => {
  return useMutation({
    mutationFn: (
      params:
        | {
            versionId: string;
            sessionId?: string;
            dateFrom: string;
            dateTo: string;
          }
        | {
            versionId?: string;
            sessionId: string;
            dateFrom: string;
            dateTo: string;
          },
    ) => analyticsApi.deleteSessions(params),
    onSuccess: () => {
      reactQueryUtils.invalidateQueries([...analyticsKeys.analytics], {
        refetchType: "active",
      });
    },
  });
};
